import axInst from '../_helpers/axios-instance';

export const brandsService = {
  getAllBrands,
};

function getAllBrands() {
  return axInst.post('/api/get-trademarks/all/', {});
}
